function dateValue(value) { return new Date(`${String(value).slice(0, 10)}T00:00:00.000Z`); }
function overlapDays(leftFrom, leftTo, rightFrom, rightTo) {
    const startsOn = leftFrom > rightFrom ? leftFrom : rightFrom;
    const endsOn = leftTo < rightTo ? leftTo : rightTo;
    if (endsOn <= startsOn) return 0;
    return Math.round((dateValue(endsOn) - dateValue(startsOn)) / 86400000);
}

function weekState(intervals, week) {
    const matches = (Array.isArray(intervals) ? intervals : [])
        .map(interval => ({
            interval,
            days: overlapDays(
                interval.starts_on,
                interval.ends_on,
                week.visible_starts_on,
                week.visible_ends_on
            )
        }))
        .filter(item => item.days > 0)
        .sort((left, right) => right.days - left.days ||
            String(left.interval.starts_on).localeCompare(
                String(right.interval.starts_on)
            ));
    if (!matches.length) return null;
    return {
        interval: matches[0].interval,
        mixed: matches.length > 1 || matches[0].days < overlapDays(
            week.visible_starts_on,
            week.visible_ends_on,
            week.visible_starts_on,
            week.visible_ends_on
        )
    };
}


function addDays(value, days) { const d = dateValue(value); d.setUTCDate(d.getUTCDate() + days); return d.toISOString().slice(0, 10); }
function currentWeek(date) { const d = dateValue(date); const from = addDays(date, -((d.getUTCDay() + 6) % 7)); return {visible_starts_on: from, visible_ends_on: addDays(from, 7)}; }
module.exports = {overlapDays, weekState, addDays, currentWeek};
